	$("[data-fancybox]").fancybox({
    // loop : false,
    // margin : [44, 0],
    // gutter : 50,
    // infobar : true,
    // toolbar : true,
    // buttons : [
    //     'slideShow',
    //     'fullScreen',
    //     'thumbs',
    //     'share',
    //     //'download',
    //     //'zoom',
    //     'close'
    // ],
	});